// @flow
import { useContext } from 'react';

import { EstimateContext } from '../contexts/EstimateContext';

/**
 * Extracts the average spend after discount from an estimate object.
 *
 * @param {Object} estimate - The estimate object
 * @returns {number} The average spend after discount
 */
export const getAvgSpendAfterDiscount = (estimate) => {
  return Number(estimate?.avg_spend_after_discount ?? 0);
};

export const useEstimateACVAfterDiscount = () => {
  const estimate = useContext(EstimateContext);
  return getAvgSpendAfterDiscount(estimate);
};
